const transPromiseResolvers = new Map<string, () => void>();
const timeoutMs = 200;
let lastWsTransId: string = "-1";

export async function wsMsgWithLaterTransId(
  transId: string | null | undefined,
): Promise<void> {
  return new Promise<void>((resolve) => {
    if (!transId || beforeLastWsMsgTransId(transId)) {
      resolve();
      return;
    }

    const timeout = window.setTimeout(() => {
      console.error("Timed-out waiting for transaction '" + transId + "'!");
      transPromiseResolvers.delete(transId);
      resolve();
    }, timeoutMs);

    transPromiseResolvers.set(transId, () => {
      clearTimeout(timeout);
      resolve();
    });
  });
}

export function handleWsTransId(transId: string) {
  if (beforeLastWsMsgTransId(transId)) return;

  lastWsTransId = transId;

  const mutationPromisesToResolve = Array.from(
    transPromiseResolvers.keys(),
  ).filter(beforeLastWsMsgTransId);

  mutationPromisesToResolve.forEach((id) => {
    const resolver = transPromiseResolvers.get(id);
    if (resolver) {
      resolver();
      transPromiseResolvers.delete(id);
    }
  });
}

function beforeLastWsMsgTransId(transId: string) {
  return BigInt(transId) <= BigInt(lastWsTransId);
}
